<template>
  <div class="intro">
    <h1 class="title is-centered mt-1 mb-1" v-html="$t('exam.rules-header')" />
    <p class="is-centered" v-html="$t('exam.rules-notice')" />
    <ul class="rules pl-2 mt-2">
      <li
        v-html="
          $tc('exam.rules.1', exam.max_attempts, {
            attempts: exam.max_attempts,
            current: exam.current_attempt_no,
          })
        "
      />
      <li
        v-html="$tc('exam.rules.2', exam.duration, { duration: exam.duration })"
      />
      <li v-html="$t('exam.rules.3')" />
      <li v-html="$t('exam.rules.4', { pass_rate: exam.pass_rate })" />
      <li
        v-html="
          $tc('exam.rules.5', exam.grace_period_between_attempts, {
            grace: exam.grace_period_between_attempts,
          })
        "
      />
      <li
        v-html="
          $tc('exam.rules.6', exam.max_attempts, {
            attempts: exam.max_attempts,
          })
        "
      />
      <li
        v-html="
          $tc('exam.rules.7', exam.max_attempts, {
            attempts: exam.max_attempts,
          })
        "
      />
      <li v-html="$t('exam.rules.8')" />
    </ul>
    <div class="columns">
      <div class="column is-12 is-centered">
        <button
          class="button is-large is-success mt-2"
          @click="$emit('begin')"
          v-html="$t('exam.begin-examination')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamIntro',

  props: {
    exam: { type: Object, required: true }
  }
};
</script>
